module.exports = __webpack_public_path__ + "kellerwatches.jpg?06210c240d687e9972b37025d7f9a675";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/kellerwatches.jpg
// module id = 130
// module chunks = 0